var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8959 16.4386C25.8959 15.8066 25.8399 15.2066 25.7439 14.6226H16.7039V18.2306H21.8799C21.6479 19.4146 20.9679 20.4146 19.9599 21.0946V23.4946H23.0479C24.8559 21.8226 25.8959 19.3586 25.8959 16.4386Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.704 25.8227C19.296 25.8227 21.464 24.9587 23.048 23.4947L19.96 21.0947C19.096 21.6707 18 22.0227 16.704 22.0227C14.2 22.0227 12.08 20.3347 11.32 18.0547H8.13599V20.5267C9.71199 23.6627 12.952 25.8227 16.704 25.8227Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.32 18.0546C11.12 17.4786 11.016 16.8626 11.016 16.2226C11.016 15.5826 11.128 14.9666 11.32 14.3906V11.9186H8.136C7.48 13.2146 7.104 14.6706 7.104 16.2226C7.104 17.7746 7.48 19.2306 8.136 20.5266L11.32 18.0546Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.704 10.4226C18.12 10.4226 19.384 10.9106 20.384 11.8626L23.12 9.12662C21.464 7.57462 19.296 6.62262 16.704 6.62262C12.952 6.62262 9.71199 8.78262 8.13599 11.9186L11.32 14.3906C12.08 12.1106 14.2 10.4226 16.704 10.4226Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.4a8cee381f309c17bbad23b6e0e96d1c.svg";
export { ForwardRef as ReactComponent };